module.exports = __webpack_public_path__ + "img/Drinks-low.8908ba3d.jpg";